<p>request-call-confirmation-dialog works!</p>
